module.exports = __webpack_public_path__ + "media/images/cover_station-9483f41cf92f47ff90bd396a0885f2df.jpg";